import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { isEmpty } from 'dpl/shared/utils/object';
import ErrorWrapper from 'dpl/form/components/ErrorWrapper';

export default class UserAuthResetPasswordForm extends Component {
  static propTypes = {
    handleFormSubmission: PropTypes.func.isRequired,
    isFormSubmitting: PropTypes.bool.isRequired,
    didFormSubmissionFail: PropTypes.bool.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    formErrors: PropTypes.object.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    formState: PropTypes.object.isRequired,
    handleFormFieldChange: PropTypes.func.isRequired,
    unverifiedLogin: PropTypes.bool.isRequired
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props
      .handleFormSubmission({ unverified_login: this.props.unverifiedLogin })
      .then(() => {
        window.location = '/account';
      });
  };

  render() {
    const {
      isFormSubmitting,
      didFormSubmissionFail,
      formState,
      formErrors,
      handleFormFieldChange
    } = this.props;

    return (
      <form className="UserAuthResetPasswordForm" onSubmit={this.handleSubmit}>
        <h1 className="mb4 f6">Reset your password</h1>

        <div className="mb6">
          <label htmlFor="password">
            <p className="dark-gray mb2 f2">Password</p>
            <ErrorWrapper
              errors={formErrors.password}
              isShown={didFormSubmissionFail}
            >
              <input
                name="password"
                type="password"
                className="UserAuthResetPasswordForm__input w-100 br1 ba b--light-gray ph4 pv2"
                value={formState.password || ''}
                onChange={handleFormFieldChange}
                placeholder="6+ characters"
              />
            </ErrorWrapper>
          </label>
        </div>

        <div className="mb10">
          <label htmlFor="password_confirmation">
            <p className="dark-gray mb2 f2">Password (confirm)</p>
            <ErrorWrapper
              errors={formErrors.password_confirmation}
              isShown={didFormSubmissionFail}
            >
              <input
                type="password"
                name="password_confirmation"
                className="UserAuthResetPasswordForm__input w-100 br1 ba b--light-gray ph4 pv2"
                value={formState.password_confirmation || ''}
                onChange={handleFormFieldChange}
              />
            </ErrorWrapper>
          </label>
        </div>

        <button
          className={`button button--primary ph14 pv4 center ${
            isFormSubmitting ? 'button--loading' : ''
          }`}
          disabled={isFormSubmitting || !isEmpty(formErrors)}
          type="submit"
        >
          Set new password
        </button>
      </form>
    );
  }
}
